export type InfoDialogTranslation = {
  buttons: {
    close: string;
    ok: string;
  };
  title: string;
};

export const infoDialogTranslation: InfoDialogTranslation = {
  buttons: {
    close: 'Close',
    ok: 'Ok',
  },
  title: 'Information',
};
